module.exports = {
    common: {
        requestProcessFail: 'Pemrosesan permintaan gagal',
        requestFail: 'Permintaan gagal',
        networkError: 'Permintaan jaringan gagal, silakan coba lagi nanti',
        notFound: 'Alamat permintaan tidak ditemukan',
        serverError: 'Kesalahan server internal',
        selectCountry: 'Silakan pilih negara',
        confirmed: 'Dikonfirmasi',
        cancelled: 'Dibatalkan...',
        back: 'Kembali',
    },

    homePage: {
        alreadyUse: 'Terpakai',
        remain: 'Tersisa',
        search: 'Cari',
        findIccid: 'Cara menemukan ICCID',
        fillIccid: 'Isi nomor SIM Card ICCID',
        changeLanguage: 'Ganti Bahasa',
        confirm: 'Konfirmasi',
        selectLanguage: 'Silakan pilih bahasa',
        selectImageFile: 'Silakan pilih file gambar',
        processing: 'Sedang diproses...',
        recognizeSuccess: 'Berhasil dikenali',
        recognizeFail: 'Pengenalan gagal, silakan coba lagi',
        recognizeEmpty: 'ICCID tidak dikenali',
        compressFail: 'Kompresi gagal',
        takePhoto: 'Ambil Foto',
        fromAlbum: 'Pilih dari Album',
        recognizing: 'Sedang mengenali...',
        openingCamera: 'Membuka kamera...',
        cameraFail: 'Gagal membuka kamera',
        scanFail: 'Pengenalan gagal. Arahkan ke kode QR',
    },
    planPage: {
        contact: 'Whatsapp/Ponsel',
        expireNotify: 'Pratinjau real-time tidak bisa diakses setelah paket habis. Harap perpanjang tepat waktu.',
        dataUsed: 'Terpakai',
        dataRemain: 'Tersisa',
        planStatus: 'Status',
        planAutoRenew: 'Perpanjangan Otomatis',
        planOrders: 'Detail Pesanan',
        planCountry: 'Negara',
        planPackage: 'Paket',
        realPakcage: '9.9 Rm / 30 Hari',
        autoRenewNotify: 'Paket akan diperpanjang otomatis setiap 30 hari dengan biaya Rp30.000. Bisa dibatalkan kapan saja.',
        goForPurchase: 'Beli sekarang',
        every: 'Berlangganan',
        subscribe: 'Subscribe',
        subscribeInfo: 'setiap',
        subscribeInfo01: 'hari. Perpanjangan otomatis, fleksibel untuk dibatalkan kapan saja.',
        days: 'Hari',
        lifetimeFreeFlow: 'Data Gratis Seumur Hidup',
        renew: 'Perbarui Paket, Batalkan Kapan Saja',
        detail: 'Rincian',
        nodata: 'Tidak Ada Paket Tersisa',
        autoRenewSaying: 'Pernyataan perpanjangan otomatis',
        autoRenewSay1: 'Anda dapat membatalkan perpanjangan otomatis kapan saja dan tidak ada biaya lebih lanjut yang akan dikenakan setelah pembatalan.',
        autoRenewSay2: 'Nikmati harga super rendah.',
        renewNoticeTitle: 'Pemberitahuan Penting',
        renewNotice1: 'Paket Anda akan diaktifkan segera setelah pembayaran berhasil.',
        renewNotice2: 'Ini adalah langganan dengan perpanjangan otomatis. Harap tinjau detailnya sebelum membeli.',
        agreePrefix: 'Dengan melanjutkan, Anda menyetujui ',
        subscribePolicy: 'Kebijakan Berlangganan',
        agreeMiddle: ' dan ',
        refundPolicy: 'Kebijakan Pengembalian Dana',
        agreeSuffix: '.',
        close: 'Penutup',
        subscription: 'Berhenti berlangganan',
        cancelSubscription: 'Konfirmasi Berhenti Berlangganan？',
        conform: 'mengonfirmasi',
        cancel: 'Membatalkan',
        Unlimited:'Unlimited',
        cardLeftTip: '360+180 Gratis',
        cardLeftTip270: '180+90 Gratis',
        purchaseTitle: 'Beli Paket'
    },
    couponRedeem: {
        title: 'Kupon Perpanjangan Eksklusif',
        titleNewbie: 'Kupon Eksklusif Pengguna Baru',
        subtitle: 'Terima kasih telah bersama kami!',
        bullet1: 'Terbatas satu kupon per ICCID',
        bullet2: 'Berlaku hingga {date}',
        bullet3: 'Hanya satu kali!',
        claimNow: 'Klaim Sekarang',
        goToUse: 'Gunakan',
        receiveSuccess: 'Berhasil diklaim',
        receiveMissing: 'Kupon atau ICCID tidak valid.',
        useToast: 'Gunakan kupon ini saat membayar paket Anda.',
        claimToast: 'Silakan hubungi layanan pelanggan untuk menyelesaikan penukaran.',
        empty: 'Belum ada kupon',
        noCouponMsg: 'Tidak ada kupon',
        buyDirect: 'Beli Langsung',
        loading: 'Memuat...',
    },
    payPage: {
        paymentConfirm: 'Payment Confirm',
        payContact: 'Kontak',
        payPackage: 'Paket',
        payDuration: 'Durasi',
        payTotal: 'Total',
        paySelectPayment: 'Pilih Metode Pembayaran',
        payCard: 'Kartu',
        cardDesc: 'Hanya Mendukung Langganan',
        payCardBankCredit: 'Kartu Bank / Kredit',
        cardSupportHint: 'Mendukung Visa, Mastercard, Apple Pay, Google Pay',
        currentSelected: 'Pilihan saat ini',
        autoBadge: 'Otomatis',
        subscribeCardDeduct: 'Langganan kartu kredit/debit',
        subscribeEwalletDeduct: 'Langganan dompet digital',
        payOnceTitle: 'Pembayaran Sekali',
        payOnceDesc: 'Pembayaran sekali, tidak ada perpanjangan otomatis; satu metode pembayaran per baris.',
        rechargeEwalletDesc: 'Pembayaran sekali dompet digital',
        rechargeQrisDesc: 'Pembayaran scan kode',
        rechargeBankDesc: 'Pembayaran sekali transfer bank',
        rechargeRetailDesc: 'Pembayaran toko serba ada',
        payEWallet: 'Pembayaran',
        payComfirm: 'Konfirmasi Pembayaran',
        paymentSecureHint: 'Informasi pembayaran Anda aman dan terenkripsi.',
        inputContact: 'Silakan masukkan informasi kontak',
        contactAppNumber: 'Nomor {app}',
        contactUpdateViaApp: 'Pembaruan pesanan akan dikirim melalui {app}',
        contactPhonePlaceholder: 'Masukkan nomor',
        contactPhoneMinLength: 'Minimal 8 digit',
        orderCouponLoading: 'Memuat kupon...',
        couponAppliedSub: 'Diterapkan pada pesanan ini',
        couponAvailableSub: 'Tersedia untuk pesanan ini',
        couponDeductLabel: 'Diskon kupon',
        amountAfterDeduction: 'Jumlah setelah diskon',
        subscribeDetailTitle: 'Detail Langganan (Perpanjangan Otomatis)',
        subscribeDetailSubtitle: 'Lihat siklus penagihan, aturan perpanjangan, pembatalan & lainnya',
        subscribeDetailIntro: 'Ini adalah langganan dengan perpanjangan otomatis. Dengan melanjutkan, Anda menyetujui ketentuan di bawah ini.',
        subscribeBillingCycle: 'Siklus Penagihan',
        subscribeBillingCycleVal: 'Setiap {days} hari',
        subscribeAmount: 'Jumlah',
        subscribeAmountVal: '{amount} per {days} hari',
        subscribeNextRenewal: 'Perpanjangan Berikutnya',
        subscribeNextRenewalVal: 'Pada tanggal kedaluwarsa, jumlah akan ditagih secara otomatis.',
        subscribePaymentMethod: 'Metode Pembayaran',
        subscribePaymentMethodVal: 'Perpanjangan berikutnya akan ditagih ke metode pembayaran ini.',
        subscribeCancelAnytime: 'Batalkan Kapan Saja',
        subscribeCancelAnytimeVal: 'Anda dapat membatalkan perpanjangan otomatis kapan saja sebelum tanggal penagihan berikutnya. Setelah pembatalan, paket tetap aktif hingga kedaluwarsa.',
        subscribeActivation: 'Aktivasi',
        subscribeActivationVal: 'Paket Anda akan diaktifkan segera setelah pembayaran berhasil.',
        refundSummaryTitle: 'Kebijakan Pengembalian Dana (Ringkasan)',
        refundSummarySubtitle: 'Lihat kelayakan, proses & pengecualian pengembalian dana',
        refundSummaryIntro: 'Pengembalian dana hanya tersedia dalam kasus berikut:',
        refundSummaryCase1: 'Pembayaran duplikat',
        refundSummaryCase2: 'Pembayaran berhasil tetapi paket belum diaktifkan',
        refundSummaryCase3: 'Masalah teknis yang disebabkan oleh Franwell',
        refundSummaryDisclaimer: 'Tidak ada pengembalian dana setelah paket berhasil diaktifkan atau digunakan sebagian.',
        refundSummaryLink: 'Lihat Kebijakan Pengembalian Dana Lengkap',
        agreeAutoRenew: 'Saya memahami ini adalah langganan dengan perpanjangan otomatis dan menyetujui ketentuan di atas.',
        agreePoliciesPrefix: 'Saya telah membaca dan menyetujui ',
        agreeAutoRenewRequired: 'Harap konfirmasi ketentuan langganan perpanjangan otomatis.',
        agreePoliciesRequired: 'Harap setujui Kebijakan Langganan dan Kebijakan Pengembalian Dana.',
        agreeConsentRequired: 'Harap centang kotak persetujuan di atas.',
        subscribePolicyPopupTitle: 'Kebijakan Langganan',
        subscribePolicySection1Title: '1. Langganan',
        subscribePolicyS1Item1: 'Langganan Anda akan dimulai segera setelah pembayaran berhasil.',
        subscribePolicyS1Item2: 'Setiap langganan berlaku selama {days} hari.',
        subscribePolicyS1Item3: 'Langganan Anda akan diperpanjang otomatis setiap {days} hari.',
        subscribePolicyS1Item4: 'Jumlah perpanjangan adalah {amount} per {days} hari.',
        subscribePolicyS1Item5: 'Pembayaran perpanjangan akan ditagih otomatis ke metode pembayaran yang Anda pilih.',
        subscribePolicyS1Item6: 'Anda dapat membatalkan perpanjangan otomatis kapan saja sebelum tanggal penagihan berikutnya.',
        subscribePolicyS1Item7: 'Setelah pembatalan, langganan Anda saat ini tetap aktif hingga kedaluwarsa.',
        subscribePolicySection2Title: 'Panduan Pembatalan Langganan',
        subscribePolicyS2Step1Label: 'Langkah 1',
        subscribePolicyS2Step1: 'Buka halaman 4G',
        subscribePolicyS2Step2Label: 'Langkah 2',
        subscribePolicyS2Step2: 'Temukan tombol langganan',
        subscribePolicyS2Step3Label: 'Langkah 3',
        subscribePolicyS2Step3: 'Ketuk "Matikan Perpanjangan Otomatis"',
        subscribePolicyS2Step4Label: 'Langkah 4',
        subscribePolicyS2Step4: 'Konfirmasi pembatalan',
        subscribePolicyS2Tip: 'Anda masih dapat menggunakan layanan ini hingga akhir periode langganan saat ini.',
        subscribePolicyFullLink: 'Lihat Kebijakan Langganan Lengkap',
        xenditSubscribeNoticeTitle: 'Pemberitahuan Penting',
        xenditSubscribeNotice1: 'Anda berlangganan antara tanggal 29 hingga 31.',
        xenditSubscribeNotice2Prefix: 'Langganan Anda akan berhasil, tetapi penagihan sebenarnya akan ditunda hingga ',
        xenditSubscribeNotice2Highlight: 'hari pertama bulan berikutnya.',
        xenditSubscribeNotice3: 'Kami akan memberikan hari penggunaan gratis untuk periode ini. Setelah pembayaran dipotong, hari paket Anda akan diperpanjang secara otomatis.',
        xenditSubscribeNoticeConfirm: 'Mengerti',
        refundPolicyPopupTitle: 'Kebijakan Pengembalian Dana',
        refundPolicySection1Title: '1. Memenuhi Syarat Pengembalian Dana',
        refundPolicyS1Intro: 'Pengembalian dana akan diberikan dalam kasus berikut:',
        refundPolicyS1Item1: 'Pembayaran duplikat',
        refundPolicyS1Item2: 'Pembayaran berhasil tetapi paket belum diaktifkan',
        refundPolicyS1Item3: 'Masalah teknis yang disebabkan oleh Franwell',
        refundPolicySection2Title: '2. Tidak Memenuhi Syarat Pengembalian Dana',
        refundPolicyS2Intro: 'Pengembalian dana tidak akan diberikan dalam kasus berikut:',
        refundPolicyS2Item1: 'SIM telah diaktifkan dan layanan data telah digunakan',
        refundPolicyS2Item2: 'Penggunaan sebagian atau penuh paket',
        refundPolicyS2Item3: 'Perubahan pikiran setelah pembelian',
        refundPolicyS2Item4: 'Masalah jangkauan jaringan atau sinyal setelah aktivasi berhasil',
        refundPolicySection3Title: '3. Proses Pengembalian Dana',
        refundPolicyS3Item1: 'Pengembalian dana akan diproses dalam 3-5 hari kerja.',
        refundPolicyS3Item2: 'Pengembalian dana akan dikembalikan ke metode pembayaran asal.',
        selectPaymentRequired: 'Silakan pilih metode pembayaran',
        paymentLinkInvalid: 'Tautan pembayaran tidak valid',
        redirectPaymentFailed: 'Gagal membuka halaman pembayaran. Silakan coba lagi secara manual.',
        createOrderFailed: 'Gagal membuat pesanan',
        creatingOrder: 'Sedang membuat pesanan untuk pembayaran...',
        paymentComponentLoadFailedRefresh: 'Gagal memuat komponen pembayaran. Silakan segarkan halaman.',
        paymentComponentLoadFailed: 'Gagal memuat komponen pembayaran',
        paymentFailed: 'Pembayaran gagal',
        paymentCancelled: 'Pembayaran dibatalkan',
        paymentInitFailed: 'Inisialisasi pembayaran gagal',
        indonesiaPhoneInvalid: 'Format salah. Masukkan nomor telepon Indonesia yang valid',
    },
    paySuccessPage: {
        pendingResult: 'Hasil Pesanan Tertunda',
        activationSuccess: 'Aktivasi Kartu SIM Anda Berhasil Dikirim',
        activationQuery: 'Cek Status Aktivasi',
        pendingPaymentTitle: 'Pembayaran Pesanan Tertunda',
        orderNoLabel: 'No. Pesanan',
        redirectingPayment: 'Mengalihkan ke pembayaran...',
        pay: 'Bayar',
        orderNoMissing: 'Nomor pesanan tidak ada',
        paymentLinkInvalid: 'Tautan pembayaran tidak valid',
    },
    orderPage: {
        orderRecords: 'Order Records',
        activated: 'Diaktifkan',
        notActivated: 'Belum Diaktifkan',
        closed: 'Ditutup',
        activateFailed: 'Aktivasi Gagal',
        paySuccess: 'Berhasil',
        payFailed: 'Gagal',
        notPaid: 'Belum Dibayar',
        refunded: 'Sudah Direfund',
        Pending: 'Rencana Tertunda',
        orderRecord: 'Riwayat Pesanan',
        orderStatus: 'Status Pesanan',
        orderPayStatus: 'Status Pembayaran',
        orderCountry: 'Negara',
        orderPackage: 'Paket',
        orderIccid: 'ICCID',
        orderOrderTime: 'Waktu Pesanan',
        back: 'kembali'
    },
    deviceInfo: {
        title: 'Informasi Perangkat',
        userId: 'ID Pengguna',
        deviceId: 'ID Perangkat',
        operatorAlertTitle: 'Pemberitahuan Pembukaan Kunci',
        operatorAlert:
            'Perangkat ini telah menerima subsidi resmi sehingga tersedia dengan harga yang lebih menguntungkan dan disertai kartu SIM 4G resmi untuk pengalaman penggunaan terbaik. Jika Anda ingin menghapus pembatasan, Anda dapat memilih untuk membukanya dengan biaya tertentu. Setelah dibuka kuncinya, Anda dapat menggunakan kartu SIM lain yang kompatibel.',
        unlockPermanent: 'Buka kunci permanen',
        unlockDescription: 'Pembayaran satu kali, buka kunci perangkat secara permanen',
        unlockDescription01: 'Setelah dibuka, Anda dapat menggunakan kartu SIM dari operator mana pun.',
        unlockImmediate: 'Buka Kunci Sekarang',
        noticeTitle: 'Petunjuk Pembukaan Kunci',
        unlockNotice:
            'Pengingat: Jika Anda sudah melakukan pembayaran, proses pembukaan kunci akan berlaku dalam waktu 5–10 menit. Harap tetap terhubung ke jaringan dan coba lagi nanti.'
    },

    deviceUnlockPaymentInfo: {
        title: 'Informasi Perangkat',
        userId: 'ID Pengguna',
        deviceId: 'ID Perangkat',
        total: 'Total',
        paySelectPayment: 'Pilih Metode Pembayaran',
        payCard: 'Kartu',
        payEWallet: 'Dompet Digital',
        payConfirm: 'Konfirmasi Pembayaran',
        operatorAlert:
            'Perangkat ini telah menerima subsidi resmi sehingga tersedia dengan harga yang lebih menguntungkan dan disertai kartu SIM 4G resmi untuk pengalaman penggunaan terbaik. Jika Anda ingin menghapus pembatasan, Anda dapat memilih untuk membukanya dengan biaya tertentu. Setelah dibuka kuncinya, Anda dapat menggunakan kartu SIM lain yang kompatibel.',
        unlockPermanent: 'Buka kunci permanen',
        unlockDescription: 'Pembayaran satu kali, buka kunci perangkat secara permanen',
        unlockDescription01: 'Setelah dibuka, Anda dapat menggunakan kartu SIM dari operator mana pun.',
        unlockImmediate: 'Buka Kunci Sekarang',
        noticeTitle: 'Petunjuk Pembukaan Kunci',
        unlockNotice:
            'Pengingat: Jika Anda sudah melakukan pembayaran, proses pembukaan kunci akan berlaku dalam waktu 5–10 menit. Harap tetap terhubung ke jaringan dan coba lagi nanti.',
        unlockConfirm: 'Konfirmasi',
        unlockRequestFail: 'Permintaan gagal',
        unlockTipsTitle: 'Tips',
        unlockedMsg: 'Produk ini sudah dibuka kuncinya, tidak perlu melakukan operasi ulang!',
        UnlockSuccessful: 'Selamat! Pembukaan kunci berhasil!'
    },
    feedbackPage: {
        title: 'Umpan Balik',
        heroTitle: 'Ceritakan apa yang terjadi',
        heroSubtitle: 'Kami akan membantu Anda secepat mungkin.',
        ticketHistory: 'Riwayat Tiket Saya',
        problemCategory: 'Kategori Masalah',
        issueSelectTitle: 'Silakan pilih masalah spesifik',
        issueSelectSubtitle: 'Pilih satu yang paling sesuai dengan situasi Anda.',
        next: 'Berikutnya',
        form: {
            describeTitle: 'Jelaskan Masalah Anda',
            describeSubtitle: 'Harap berikan detail lebih lanjut tentang masalah yang Anda alami.',
            describePlaceholder: 'Harap jelaskan masalah Anda di sini... (Maks 500 karakter)',
            uploadPhotoTitle: 'Unggah Foto (Opsional)',
            uploadPhotoSubtitle: 'Anda dapat mengunggah hingga 3 gambar',
            uploadScreenshotTitle: 'Unggah Tangkapan Layar (Opsional)',
            uploadScreenshotSubtitle: 'Membantu kami memahami masalah dengan lebih baik',
            contactEmailTitle: 'Email Kontak',
            contactEmailPlaceholder: 'example@email.com',
            orderNoTitle: 'Nomor Pesanan',
            orderNoPlaceholder: 'Harap masukkan nomor pesanan Anda',
            orderNoRequired: 'Harap masukkan nomor pesanan Anda',
            takePhoto: 'Ambil Foto',
            chooseFromAlbum: 'Pilih dari Album',
            cancel: 'Batal',
            emailRequired: 'Harap masukkan email kontak',
            emailInvalid: 'Harap masukkan alamat email yang valid',
            describeRequired: 'Harap jelaskan masalah Anda',
            uploading: 'Mengunggah...',
            uploadFailed: 'Unggah gambar gagal, silakan coba lagi',
            submitting: 'Mengirim...',
            submitFailed: 'Pengiriman gagal, silakan coba lagi',
            confirmSelected: 'Anda memilih:',
            pleaseMakeSure: 'Harap pastikan:',
            checkSimInserted: 'Kartu SIM terpasang dengan benar',
            checkDataPlanActive: 'Paket data Anda aktif',
            checkCameraPowered: 'Kamera dalam keadaan menyala',
            checkSignalStrength: 'Kekuatan sinyal minimal 2 bar',
            checkRestartCamera: 'Coba restart kamera',
            confirmPrompt: 'Harap konfirmasi masalah di atas',
            submit: 'Kirim',
        },
        success: {
            title: 'Berhasil Dikirim!',
            subtitle: 'Tim dukungan kami telah menerima permintaan Anda.',
            ticketNumber: 'Nomor Tiket',
            submitTime: 'Waktu Kirim',
            responseTime: 'Kami akan menghubungi Anda dalam 24 jam (hari kerja).',
            statusCheck: 'Anda dapat memeriksa status di "Tiket Saya".',
            myTickets: 'Tiket Saya',
            backToHome: 'Kembali ke Beranda',
            copySuccess: 'Berhasil disalin',
        },
        categories: {
            camera: { title: 'Kamera', desc: 'Kamera offline, tidak bisa melihat, night vision' },
            sim: { title: 'SIM / Jaringan', desc: 'Tidak ada jaringan, sinyal lemah, masalah SIM' },
            recharge: { title: 'Isi Ulang / Paket', desc: 'Isi ulang gagal, paket tidak diperbarui, refund' },
            data: { title: 'Penggunaan Data', desc: 'Penggunaan data tinggi, sisa data tidak benar' },
            device: { title: 'Fungsi Perangkat', desc: 'Deteksi gerakan, cloud storage, rekaman' },
            order: { title: 'Pesanan & Pembayaran', desc: 'Pembayaran gagal, refund, faktur' },
            other: { title: 'Lainnya', desc: 'Masalah lainnya' },
        },
        issues: {
            camera_offline: 'Kamera Offline',
            cannot_view_live: 'Tidak Bisa Melihat Langsung',
            playback_failed: 'Pemutaran Gagal',
            night_vision: 'Masalah Night Vision',
            motion_detection: 'Deteksi Gerakan',
            camera_restart: 'Restart Kamera',
            camera_not_added: 'Kamera Belum Ditambahkan',
            sim_not_activated: 'SIM Belum Diaktifkan',
            no_network: 'Tidak Ada Jaringan',
            weak_signal: 'Sinyal Lemah',
            roaming_issue: 'Masalah Roaming',
            sim_replacement: 'Penggantian SIM',
            cannot_detect_sim: 'SIM Tidak Terdeteksi',
            '4g_not_working': '4G Tidak Berfungsi',
            recharge_failed: 'Isi Ulang Gagal',
            recharge_not_effective: 'Isi Ulang Berhasil Tapi Tidak Berlaku',
            plan_not_updated: 'Paket Tidak Diperbarui',
            wrong_package: 'Paket Salah',
            auto_renewal: 'Perpanjangan Otomatis',
            subscription: 'Langganan',
            refund: 'Refund',
            coupon: 'Kupon',
            high_data_usage: 'Penggunaan Data Tinggi',
            data_used_too_fast: 'Data Terpakai Terlalu Cepat',
            remaining_data_incorrect: 'Sisa Data Tidak Benar',
            usage_not_updated: 'Penggunaan Tidak Diperbarui',
            need_usage_report: 'Butuh Laporan Penggunaan',
            payment_failed: 'Pembayaran Gagal',
            duplicate_payment: 'Pembayaran Ganda',
            order_not_found: 'Pesanan Tidak Ditemukan',
            invoice: 'Faktur',
            discount: 'Diskon',
            cloud_storage: 'Penyimpanan Cloud',
            recording: 'Rekaman',
            sd_card: 'Kartu SD',
            notification: 'Notifikasi',
            firmware_upgrade: 'Upgrade Firmware',
            device_binding: 'Pemasangan Perangkat',
            qr_code: 'Kode QR',
            reset_device: 'Reset Perangkat',
            other: 'Lainnya',
        },
        history: {
            tabs: {
                all: 'Semua',
                processing: 'Diproses',
                waiting: 'Menunggu',
                resolved: 'Selesai',
                closed: 'Ditutup',
            },
            status: {
                processing: 'Diproses',
                waiting: 'Menunggu',
                resolved: 'Selesai',
                closed: 'Ditutup',
            },
            deviceId: 'ID Perangkat',
            iccid: 'ICCID',
            submitTime: 'Waktu Kirim',
            empty: 'Tidak ada tiket',
            loading: 'Memuat...',
        },
    },

    PositiveReviewCashbackPopup:{
        title: 'Dapatkan kuota gratis!',
        tip: 'dengan memberikan ulasan 5 bintang',
        confirm: 'Ambil Sekarang'
    },

    newbieCouponPopup: {
        titleOffer: 'Penawaran Eksklusif',
        noThreshold: 'Kupon Tanpa Syarat',
        fullReduction: 'Kupon Potongan Minimal Belanja',
        nonSubscribeOnly: 'Khusus paket non-langganan',
    }
}
